<template>
  <div class="ApplicationList">
    <application-section
      :app-types="applicationTypes"
      :title="$t('ApplicationsList_Apps')"
    ></application-section>
    <application-section
      :app-types="websiteTypes"
      :title="$t('ApplicationsList_Websites')"
    ></application-section>
  </div>
</template>

<script>
import ApplicationSection from '@/modules/account/components/ApplicationSection'
import { ApplicationTypes } from '@/modules/account/enum/ApplicationEnum'

export default {
  name: 'ApplicationList',

  components: { ApplicationSection },

  data() {
    return {
      ...ApplicationTypes
    }
  },

  computed: {
    applicationTypes() {
      return [ApplicationTypes.android, ApplicationTypes.ios].join(',')
    },

    websiteTypes() {
      return [ApplicationTypes.web].join(',')
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/components/ApplicationList.vue